import React from 'react';
import { Col, Row } from 'reactstrap';
import Consumption from './components/Consumption';
import DaysComponent from './components/Days';
import UserInfo from './components/UserInfo';
import HistoryRoads from './components/HistoryRoads';
import { useQuery } from '@apollo/client';
import { Navigate, useParams } from 'react-router-dom';
import { GET_USER_DETAILS } from '../../../graphql/Query/users';

const UserView = () => {
  const id = useParams().id;

  const { data, loading, error, refetch } = useQuery(GET_USER_DETAILS, {
    variables: {
      id
    },
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'network-only'
  });

  if (loading) {
    return null;
  }

  if (error) {
    return <Navigate to="/users/list" />;
  }

  const { findUserByIdAdmin: _data } = data;

  return (
    <Row>
      <Col md={9}>
        <Row>
          <Col md={12}>
            <UserInfo data={_data} refetch={refetch} />
          </Col>
          <Col md={12}>
            <HistoryRoads id={id} />
          </Col>
        </Row>
      </Col>
      <Col md={3}>
        <Row>
          <Col md={12}>
            <DaysComponent data={_data} />
          </Col>
          <Col md={12}>
            <Consumption userId={id} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default UserView;
